"use client";

import { buttonVariants } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { GetLomdaResponseType } from "../../hooks/useGetLomda";
import { Label } from "@/components/ui/label";
import DeleteLomdaButton from "./deleteButton";
import DuplicateLomdaButton from "./duplicateButton";
import { useStorage } from "@/features/storage/useStorage";
import { t } from "@/lib/localization";

export default function LomdaSheetHeader({
    lomda,
}: {
    lomda: GetLomdaResponseType["data"];
}) {
    const setOpen = useStorage((state) => state.setLomdaSheetOpen);

    return (
        <header className="bg-white px-8 flex flex-row h-16 w-full justify-between items-center border-b">
            <div className="truncate flex flex-col">
                <Label className="truncate text-base">
                    {lomda?.name
                        ? t("lomda-sheet.header.title", undefined, { lomdaName: lomda.name })
                        : t("lomda-sheet.header.title.placeholder", undefined, undefined)}
                </Label>

                {!!lomda?.folders?.length && (
                    <p
                        className="truncate text-xs text-muted-foreground"
                        title={lomda.folders?.map((f) => f.name).join(", ")}
                    >
                        {t("lomda-sheet.header.folders", undefined, {
                                folderNames:
                                    lomda.folders
                                        ?.map((f) => f.name)
                                        .join(", ") || "",
                            })}
                    </p>
                )}
            </div>

            <div className="hidden md:flex flex-row gap-2">
                <a
                    onClick={() => {
                        setOpen(false);
                    }}
                    href={`/lomda-editor/${lomda.id}`}
                    className={buttonVariants({
                        variant: "secondary",
                        size: "sm",
                    })}
                >
                    <Pencil className="size-3.5 me-2" />
                    {t("lomda-sheet.header.edit-btn", undefined, undefined)}
                </a>
                <DuplicateLomdaButton lomda={lomda} />
                <DeleteLomdaButton lomda={lomda} />
            </div>
        </header>
    );
}
